import { useCallback, useEffect, useState } from "react";
import useAxiosClient from "../axios-client";
import { toast } from "react-toastify";

/**
 * The curated list of places ready stock is kept ("Mirpur DC", "Uttara DC").
 * Feeds the Product Settings tab and the Ready Stock placement picker.
 */
export const useStockLocations = () => {

    const axiosClient = useAxiosClient();
    const [stockLocations, setStockLocations] = useState([]);
    const [stockLocationsLoading, setStockLocationsLoading] = useState(false);

    const fetchStockLocations = useCallback(async () => {
        setStockLocationsLoading(true);
        await axiosClient.get(`/settings/stockLocations/index`).then((response) => {
            setStockLocations([...response.data.data])
            setStockLocationsLoading(false);
        }).catch((error) => {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            setStockLocationsLoading(false);
            toast.error(message);
        });
    }, [axiosClient])

    useEffect(() => {
        fetchStockLocations();
    }, [fetchStockLocations])

    return { stockLocations, stockLocationsLoading, fetchStockLocations }
}
